import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { ArrowLeft } from 'lucide-react';
import PanelButton from '../PanelButton';
import { colors } from '../../theme/colors';

const SectionTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  color: #e0e0e0;
  margin: 0 0 0.75rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const InstructionStep = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${colors.headerGradient};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(139, 92, 246, 0.3);
`;

const StepContent = styled.div`
  flex: 1;
`;

const StepTitle = styled.h4`
  font-size: 0.875rem;
  font-weight: 600;
  color: #f3f4f6;
  margin: 0 0 0.5rem 0;
`;

const StepDescription = styled.p`
  font-size: 0.75rem;
  color: #d1d5db;
  margin: 0;
  line-height: 1.5;
`;


const InstructionsPanelContent = ({ loanId }) => {
  const navigate = useNavigate();

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <button 
          onClick={() => navigate(`/document-analysis/${loanId}/documents`)}
          style={{
            background: 'none',
            border: 'none',
            color: '#e0e0e0',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 0',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.color = '#ffffff'}
          onMouseLeave={(e) => e.target.style.color = '#e0e0e0'}
        >
          <ArrowLeft size={16} />
          Back
        </button>
      </div>

      <SectionTitle>Instructions</SectionTitle>
      
      <InstructionStep>
        <StepNumber>1</StepNumber>
        <StepContent>
          <StepTitle>Upload Documents</StepTitle>
          <StepDescription>Use drag & drop or directory selection to upload your loan documents</StepDescription>
        </StepContent>
      </InstructionStep>

      <InstructionStep>
        <StepNumber>2</StepNumber>
        <StepContent>
          <StepTitle>Extract Values</StepTitle>
          <StepDescription>Process documents and extract field data automatically</StepDescription>
        </StepContent>
      </InstructionStep>

      <InstructionStep>
        <StepNumber>3</StepNumber>
        <StepContent>
          <StepTitle>Analyze Data</StepTitle>
          <StepDescription>Review matches and discrepancies (optional)</StepDescription>
        </StepContent>
      </InstructionStep>

      <InstructionStep>
        <StepNumber>4</StepNumber>
        <StepContent>
          <StepTitle>Save to Database</StepTitle>
          <StepDescription>Create loan record and activate action menu</StepDescription>
        </StepContent>
      </InstructionStep>
    </>
  );
};

export default InstructionsPanelContent;
